import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'environments/environment';
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ContratoService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public post(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url}contrato`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	// public put(data: any, id: number): Observable<any> {
	// 	return this.http
	// 		.put<any>(`${this.url}contrato/${id}/update`, {
	// 			id_sistema: id,
	// 			nome: data.value.nome,
	// 			status: data.value.status,
	// 		}, this.httpOptions)
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }

	// public delete(data: number, id: number): Observable<any> {
	// 	return this.http
	// 		.put<any>(`${this.url}contrato/${id}/update`, {
	// 			id_sistema: id,
	// 			isDeleted: data,
	// 		}, this.httpOptions)
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }

	// // public delete(id: number): Observable<SistemaInterface> {
	// //   return this.http
	// //     .delete<SistemaInterface>(`${this.url}sistema/${id}/update`, {
	// //       id_sistema: data.value.id_sistema,
	// //       nome: data.value.nome,
	// //       status: data.value.status
	// //     })
	// //     .pipe(
	// //       (res) => res,
	// //       (error) => error
	// //     );
	// // }

	public getContrato(id: number): Observable<any> {
		return this.http.get<any>(`${this.url}contrato/cliente/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	// public getDetalhado(): Observable<{ statusCode: number, message: string[], data: any }> {
	// 	return this.http.get<{ statusCode: number, message: string[], data: any }>(`${this.url}contrato/detalhado`, this.httpOptions).pipe(
	// 		(res) => res,
	// 		(error) => error
	// 	);
	// }

	public getOneByPedido(id: number): Observable<any> {
		return this.http.get<any>(`${this.url}contrato/pedido/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getContratoDescontos(id: number): Observable<any> {
		return this.http.get<any>(`${this.url}contrato-desconto/contrato/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
